import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const mySwal = withReactContent(Swal);
import { Http } from './Http';
import CONFIGURACIONES from '../util/constants';
import { AES, enc } from 'crypto-js';
export const Functions = () => {
    const showErrors = (objErrors) => {
        if (objErrors) {
            return Object.values(objErrors)
                .flat() // aplanar los arrays internos
                .join("<br/>");
            // if (objErrors.inputs) return objErrors.inputs.join('<br/>');
            // if (objErrors.validations) return objErrors.validations.join(',');
            // if (objErrors.exceptions) return objErrors.exceptions.join(',');
        }

        return '';
    };

    const save = (url, messageSuccess, dataUser, callback, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .post(url, data)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    text: `${messageSuccess}`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback();
                });
            } else {
                console.log('res', res.errors);
                
                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const saveApproval = (url, dataUser, callback, callback2, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .post(url, data)
        .then((res)=>{ 
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    html: `${res.data.aplicadoA !== CONFIGURACIONES.INIT.NULL?`Solicitud enviada a <strong>${res.data.aplicadoA}</strong>.
                        ${res.data.usuarios.length > 0?`<br/>Usuarios asignados: <strong>${res.data.usuarios}</strong>`:``}`: 
                        `Solicitud fue <strong>${res.data.accion}</strong> con Éxito. <br/>
                        ${res.data.usuarios.length > 0?`Enviado a: <strong>${res.data.usuarios}</strong>`:``}`}`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback();
                });
            } else {
                localStorage.setItem('codeError', res.httpStatus);
                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    if (callback2 !== CONFIGURACIONES.INIT.NULL) { 
                        if (res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_4O0) {
                            mySwal.fire({
                                title: 'Recalculando cuota, para solucionar el inconveniente',
                                html: 'Por favor, espere mientras se completa la operación.',
                                icon: 'info',
                                timer: 5000,
                                timerProgressBar: true,
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: async () => {
                                    mySwal.showLoading();
                                    await callback2();
                                }
                            });
                        }
                    }
                });
            }
        });
    };

    const saveWithReturn = (url, messageSuccess, dataUser, callback, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .post(url, data)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    text: `${messageSuccess}`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback(res.data);
                });
            } else {
                // console.log('res', res.errors);
                
                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const getWithReturn = (url, callback) => {
        localStorage.setItem("isRenderInit", "1");

        Http()
        .get(url)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                localStorage.setItem("isRenderInit", "0");
                callback(res.data);
            }
        });
    };

    const update = (url, messageSuccess, dataUser, callback, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .put(url, data)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    text: `${messageSuccess}`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback();
                });
            } else {
                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const deleteElement = (url, messageSuccess, messageDelete, dataUser, callback, options) => {
        options['usuarioRegistro'] = dataUser.user;
        const data = {
            body: options
        };

        mySwal.fire({
            title: '¿Estás seguro?',
            html: messageDelete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let endpoint = url;
                Http().del(endpoint, data).then((res)=>{
                    if(res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_2O4 || res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_200) {
                        mySwal.fire({
                            title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                            text: `${messageSuccess}`,
                            icon: 'success',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        }).then((result) => {
                            localStorage.setItem("isRenderInit", "0");
                            callback(res.data);
                        });
                    } else {
                        mySwal.fire({
                            title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                            html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        });
                    }
                });
            }
        });
    };

    const deleteElementWithInput = (url, messageSuccess, messageDelete, dataUser, callback, options) => {
        options['usuarioRegistro'] = dataUser.user;
        mySwal.fire({
            title: '¿Estás seguro?',
            html: messageDelete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true,
            allowOutsideClick: false,
            input: 'textarea', // Tipo de entrada: área de texto para el motivo
            inputPlaceholder: 'Escribe el motivo aquí...',
             inputValidator: (value) => {
                // Validar que el motivo no esté vacío
                if (!value || value.trim() === '') {
                    return '¡Debes ingresar un motivo!';
                }
                // Devolver null si es válido (SweetAlert2 lo interpreta como éxito)
                return null;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                let endpoint = url;
                let motivo = result.value.trim();
                options['motivo'] = motivo;
               
                const data = {
                    body: options
                };
                Http().del(endpoint, data).then((res)=>{
                    if(res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_2O4 || res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_200) {
                        mySwal.fire({
                            title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                            text: `${messageSuccess}`,
                            icon: 'success',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        }).then((result) => {
                            localStorage.setItem("isRenderInit", "0");
                            callback(res.data);
                        });
                    } else {
                        mySwal.fire({
                            title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                            html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        });
                    }
                });
            }
        });
    };

    const extornoElement = (url, messageSuccess, messageDelete, dataUser, callback, options) => {
        console.log('messages', messageDelete);
        
        options['usuarioRegistro'] = dataUser.user;
        mySwal.fire({
            title: '¿Estás seguro?',
            html: messageDelete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, extornar',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true,
            allowOutsideClick: false,
            input: 'textarea', // Tipo de entrada: área de texto para el motivo
            inputPlaceholder: 'Escribe el motivo del extorno aquí...',
            inputValidator: (value) => {
                // Validar que el motivo no esté vacío
                if (!value || value.trim() === '') {
                    return '¡Debes ingresar un motivo para el extorno!';
                }
                // Devolver null si es válido (SweetAlert2 lo interpreta como éxito)
                return null;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                let endpoint = url;
                let motivoExtorno = result.value.trim();
                options['motivoExtorno'] = motivoExtorno;
                const data = {
                    body: options
                };

                Http().del(endpoint, data).then((res)=>{
                    if(res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_2O4 || res.httpStatus == CONFIGURACIONES.RESPONSES_HTTP.CODE_200) {
                        mySwal.fire({
                            title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                            text: `${messageSuccess}`,
                            icon: 'success',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        }).then((result) => {
                            localStorage.setItem("isRenderInit", "0");
                            callback(res.data);
                        });
                    } else {
                        mySwal.fire({
                            title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                            html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        });
                    }
                });
            }
        });
    };

    const acceptOnlyNumbers = (e) => {
        if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight/.test(e.key)) {
            e.preventDefault();
        }
    };

    const showActionList = (action, list) => {
        return list.find(el => el.rel === action);
    };

    const encrypData = (data, secretKey=CONFIGURACIONES.TOKEN_SECRET) => {
        const encryptedData = AES.encrypt(data, secretKey).toString();
        return encryptedData;
    };
    const decryptData = (encryptedData, secretKey=CONFIGURACIONES.TOKEN_SECRET) => {
        const decryptedData = AES.decrypt(encryptedData, secretKey).toString(enc.Utf8);
        return decryptedData;
    };

    const signOut = (redirect, toast) => {
        toast.error(`${CONFIGURACIONES.MESSAGES.SESSION_END}`, { position: CONFIGURACIONES.POSITION.BOTTOM_RIGHT});
        localStorage.clear();

        // Evitar navegación hacia atrás antes de redirigir
        window.history.pushState(null, "", window.location.href);
        const preventGoBack = () => {
            window.history.pushState(null, "", window.location.href);
        };
        window.addEventListener("popstate", preventGoBack);

        setTimeout(() => {
            // window.location.hash="no-back-button";
            // window.location.hash="Again-No-back-button"
            window.location.href = '/'
            // redirect("/");
        }, CONFIGURACIONES.INIT.REDIRECT);
    };

    const saveUser = (url, messageSuccess, dataUser, callback, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .post(url, data)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    html: `<p class="m-0">${messageSuccess} <br/>
                                Usuario: <strong>${res.data.usuario}</strong> <br/>
                                Clave: <strong>${res.data.clave}</strong> <br/>
                                <small class="text-danger font-weigth-bold">No olvide de copiar sus credenciales antes de cerrar.</small>
                           </p>`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback();
                });
            } else {
                console.log('res', res.errors);
                
                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const updateUser = (url, messageSuccess, dataUser, callback, options) => {
        localStorage.setItem("isRenderInit", "1");
        options['usuarioRegistro'] = dataUser.user;

        // console.log('data', options);
        const data = {
            body: options
        };

        Http()
        .put(url, data)
        .then((res)=>{
            if(res.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                mySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE}</p>`,
                    html: `<p class="m-0">${messageSuccess}</p>`,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                }).then((result) => {
                    localStorage.setItem("isRenderInit", "0");
                    callback();
                });
            } else {
                console.log('res', res.errors);

                mySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(res.errors).length?showErrors(res.errors):res.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const searchPermissions = (componente_id, permiso_id_interno, lista_permisos) => {
        //console.log(`componente_id: ${componente_id} | permiso_id_interno: ${permiso_id_interno} | lista: ${lista_permisos}`);
        let boolEncontrado = false;
        lista_permisos.map(el => {
            if (el.permiso_id_interno === permiso_id_interno && el.id == componente_id) {
                boolEncontrado = true;
            }
        });

        return boolEncontrado;
    };

    const generarNumeroUnico = (array, min = 1, max = 999999) => {
        let numero;
        let maxAttempts = 1000; // Límite para evitar bucles infinitos en arrays grandes
        let attempts = 0;

        do {
            // Genera el número aleatorio
            numero = Math.floor(Math.random() * (max - min + 1)) + min;
            
            // Verifica si *al menos uno* de los objetos en el array YA tiene ese número en su 'id'
            const idEnUso = array.some(item => item.id === numero);
            
            attempts++;

            // Si el ID está en uso, repite el bucle.
            if (!idEnUso && attempts < maxAttempts) {
                return numero; // Se encontró un número único
            }
            
        } while (attempts < maxAttempts);
        
        // Si se agotan los intentos, lanza un error o devuelve null
        throw new Error('No se pudo generar un número único después de ' + maxAttempts + ' intentos.');
    };

    return {
        save,
        saveApproval,
        saveWithReturn,
        update,
        deleteElement,
        deleteElementWithInput,
        extornoElement,
        acceptOnlyNumbers,
        showActionList,
        encrypData,
        decryptData,
        signOut,
        showErrors,
        saveUser,
        updateUser,
        searchPermissions,
        generarNumeroUnico,
        getWithReturn
    };
};